/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */
/* Document
   ========================================================================== */
/**
 * 1. Correct the line height in all browsers.
 * 2. Prevent adjustments of font size after orientation changes in iOS.
 */
html {
  line-height: 1.15; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
}

/* Sections
   ========================================================================== */
/**
 * Remove the margin in all browsers.
 */
body {
  margin: 0;
}

/**
 * Render the `main` element consistently in IE.
 */
main {
  display: block;
}

/**
 * Correct the font size and margin on `h1` elements within `section` and
 * `article` contexts in Chrome, Firefox, and Safari.
 */
h1 {
  font-size: 2em;
  margin: 0.67em 0;
}

/* Grouping content
   ========================================================================== */
/**
 * 1. Add the correct box sizing in Firefox.
 * 2. Show the overflow in Edge and IE.
 */
hr {
  box-sizing: content-box; /* 1 */
  height: 0; /* 1 */
  overflow: visible; /* 2 */
}

/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd `em` font sizing in all browsers.
 */
pre {
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/* Text-level semantics
   ========================================================================== */
/**
 * Remove the gray background on active links in IE 10.
 */
a {
  background-color: transparent;
}

/**
 * 1. Remove the bottom border in Chrome 57-
 * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
 */
abbr[title] {
  border-bottom: none; /* 1 */
  text-decoration: underline; /* 2 */
  text-decoration: underline dotted; /* 2 */
}

/**
 * Add the correct font weight in Chrome, Edge, and Safari.
 */
b,
strong {
  font-weight: bolder;
}

/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd `em` font sizing in all browsers.
 */
code,
kbd,
samp {
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/**
 * Add the correct font size in all browsers.
 */
small {
  font-size: 80%;
}

/**
 * Prevent `sub` and `sup` elements from affecting the line height in
 * all browsers.
 */
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/* Embedded content
   ========================================================================== */
/**
 * Remove the border on images inside links in IE 10.
 */
img {
  border-style: none;
}

/* Forms
   ========================================================================== */
/**
 * 1. Change the font styles in all browsers.
 * 2. Remove the margin in Firefox and Safari.
 */
button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-size: 100%; /* 1 */
  line-height: 1.15; /* 1 */
  margin: 0; /* 2 */
}

/**
 * Show the overflow in IE.
 * 1. Show the overflow in Edge.
 */
button,
input {
  /* 1 */
  overflow: visible;
}

/**
 * Remove the inheritance of text transform in Edge, Firefox, and IE.
 * 1. Remove the inheritance of text transform in Firefox.
 */
button,
select {
  /* 1 */
  text-transform: none;
}

/**
 * Correct the inability to style clickable types in iOS and Safari.
 */
button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}

/**
 * Remove the inner border and padding in Firefox.
 */
button::-moz-focus-inner,
[type=button]::-moz-focus-inner,
[type=reset]::-moz-focus-inner,
[type=submit]::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

/**
 * Restore the focus styles unset by the previous rule.
 */
button:-moz-focusring,
[type=button]:-moz-focusring,
[type=reset]:-moz-focusring,
[type=submit]:-moz-focusring {
  outline: 1px dotted ButtonText;
}

/**
 * Correct the padding in Firefox.
 */
fieldset {
  padding: 0.35em 0.75em 0.625em;
}

/**
 * 1. Correct the text wrapping in Edge and IE.
 * 2. Correct the color inheritance from `fieldset` elements in IE.
 * 3. Remove the padding so developers are not caught out when they zero out
 *    `fieldset` elements in all browsers.
 */
legend {
  box-sizing: border-box; /* 1 */
  color: inherit; /* 2 */
  display: table; /* 1 */
  max-width: 100%; /* 1 */
  padding: 0; /* 3 */
  white-space: normal; /* 1 */
}

/**
 * Add the correct vertical alignment in Chrome, Firefox, and Opera.
 */
progress {
  vertical-align: baseline;
}

/**
 * Remove the default vertical scrollbar in IE 10+.
 */
textarea {
  overflow: auto;
}

/**
 * 1. Add the correct box sizing in IE 10.
 * 2. Remove the padding in IE 10.
 */
[type=checkbox],
[type=radio] {
  box-sizing: border-box; /* 1 */
  padding: 0; /* 2 */
}

/**
 * Correct the cursor style of increment and decrement buttons in Chrome.
 */
[type=number]::-webkit-inner-spin-button,
[type=number]::-webkit-outer-spin-button {
  height: auto;
}

/**
 * 1. Correct the odd appearance in Chrome and Safari.
 * 2. Correct the outline style in Safari.
 */
[type=search] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/**
 * Remove the inner padding in Chrome and Safari on macOS.
 */
[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

/**
 * 1. Correct the inability to style clickable types in iOS and Safari.
 * 2. Change font properties to `inherit` in Safari.
 */
::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/* Interactive
   ========================================================================== */
/*
 * Add the correct display in Edge, IE 10+, and Firefox.
 */
details {
  display: block;
}

/*
 * Add the correct display in all browsers.
 */
summary {
  display: list-item;
}

/* Misc
   ========================================================================== */
/**
 * Add the correct display in IE 10+.
 */
template {
  display: none;
}

/**
 * Add the correct display in IE 10.
 */
[hidden] {
  display: none;
}

:root {
  --ui-animaton-speed: 0.2s;
}

/*****************************************************
FORM ELEMENTS
*****************************************************/
/*Text*/
:host {
  /**
  * @prop --text-color: The color of the text
  */
  --text-color: var(--black);
  /**
  * @prop --font-family: The text font family
  */
  --font-family: "Source Sans Pro", sans-serif;
  /**
  * @prop --font-weight: The text font weight
  */
  --font-weight: normal;
  /**
  * @prop --font-size: The text font size
  */
  --font-size: 12px;
  /**
  * @prop --guide-color: The color of the tree guides
  */
  --guide-color: var(--darkGray);
  /**
  * @prop --item-hover-color: The color of the item on hover
  */
  --item-hover-color: var(--lightGray);
  /**
  * @prop --item-active-color: The color of the active item
  */
  --item-active-color: var(--silverGray);
  display: block;
}
:host .text {
  padding-left: var(--spacing-comp-01);
}
:host li {
  list-style: none;
  font-family: var(--font-family);
  font-size: var(--font-size);
  font-weight: var(--font-weight);
  color: var(--text-color);
  height: 20px;
  overflow: hidden;
}
:host li.tree-open {
  height: auto;
}
:host li .li-text {
  height: 100%;
  padding: 0 var(--spacing-comp-02);
  cursor: pointer;
  display: flex;
  align-items: center;
  position: relative;
}
:host li .li-text:hover {
  background-color: var(--item-hover-color);
}
:host li .li-text:active {
  background-color: var(--item-active-color);
}
:host li .li-text:focus {
  outline: none;
  box-shadow: inset 0px 0px 0px 2px var(--color-primary-active);
}
:host li .li-text--selected {
  background-color: var(--item-active-color);
}
:host li .li-text--selected:hover {
  background-color: var(--item-hover-color);
}
:host li .vertical-line {
  position: absolute;
  width: 1px;
  height: 0;
  top: 21px;
  left: 15px;
  z-index: 1;
  background-image: linear-gradient(var(--guide-color) 28%, rgba(255, 255, 255, 0) 0%);
  background-position: right;
  background-size: 1px 4px;
  background-repeat: repeat-y;
}
:host li .horizontal-line {
  position: absolute;
  width: 16px;
  height: 1px;
  top: 11px;
  z-index: 1;
  margin-left: -23px;
  top: 10px;
  background-image: linear-gradient(to right, var(--guide-color) 33%, rgba(255, 255, 255, 0) 0%);
  background-position: bottom;
  background-size: 3px 1px;
  background-repeat: repeat-x;
}
:host li .horizontal-line.display-none {
  display: none;
}
:host li .closed-opened-icons {
  position: relative;
  display: flex;
  margin-left: -2px;
}
:host li .toggle-icon {
  position: relative;
  z-index: 2;
  padding-left: 3px;
  padding-right: 3px;
  transition-property: opacity;
  transition-duration: 0.5s;
  transition-timing-function: ease;
}
:host .checkbox {
  margin-right: var(--spacing-comp-01);
}
:host .icon {
  height: 20px;
  justify-content: center;
  align-items: center;
  padding-left: 2px;
  padding-right: 2px;
}
:host .right-icon {
  margin-inline-start: auto;
  position: relative;
  top: 0;
  transition-property: top;
  transition-duration: 0.5s;
  transition-timing-function: ease;
}
:host .loading {
  opacity: 1;
  display: inline;
  right: 11px;
  top: -20px;
  position: absolute;
  z-index: 1;
  transition-property: all;
  transition-duration: 0.5s;
  transition-timing-function: ease;
  border-radius: 50%;
  width: 8px;
  height: 8px;
  border: 0.18rem solid var(--gray-04);
  border-top-color: var(--gray-01);
  animation: spin 1s infinite linear;
}
:host .loading--double {
  border-style: double;
  border-width: 0.5rem;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.label input[disabled] {
  color: red;
}

:host([disabled]) li .text {
  color: var(--darkGray);
}
:host([disabled]) .toggle-icon {
  pointer-events: none;
}

:host([downloading]) {
  pointer-events: none;
}
:host([downloading]) .right-icon {
  top: 20px;
}
:host([downloading]) .loading {
  top: 3px;
}

:host([downloaded]) .loading,
:host([downloaded]) .right-icon {
  opacity: 0;
}